import APP from "../utils/app.js"
import { isAndroidApp, isIOSApp } from "../utils/app-type-checker.js"
import { hostAppCall } from "../utils/appFunctions.js"
type Dictionary = { [key: string]: string }
type FormMap = { [key: string]: any }


export function purchase(membership:string):void {
    const productId = getProductId(membership)
    if(productId)  hostAppCall("purchaseProduct", productId)
}
export function manageProduct(productId:string|null):void {
    if (isAndroidApp() && productId) hostAppCall("manageProduct", productId)
    else hostAppCall("manageProduct")
}

// NOTE: productID is the product ID used for app subscription, and is different between Android and iOS apps.
// And membership represents both product IDs of android and iOS apps, and is only used in html.

export function getMembershipFromUrl():string|undefined {
    return getMembership(APP.getParameterFromUrl("membership"))
}
export function getMembershipFromQuery(param:string|null):string|undefined {
    return getMembership(APP.getParameterFromQuery("membership", param))
}
export function getMembership(productId:string|null):string|undefined {
    return Object.keys(subscription).find(p => subscription[p].android == productId || subscription[p].iOS == productId)
}
export function getMembershipTitle(productId:string|null):string {
    const subs:string|undefined = getMembership(productId)
    return subs ? subscription[subs].title : "Free"
}

export function getProductId(membership:string):string|null {
    const product: Dictionary|undefined = subscription[membership]
    return product != undefined ?
        isAndroidApp() ? product.android : isIOSApp() ? product.iOS : null : null
}
export function isBasic(membership: string):boolean {
    return subscription[membership] && membership.includes("basic")
}

export const subscription: FormMap = {
     "basic":       { "iOS": "basic",             "android": "basic_sub",         "price": "$39.99",   "title": "Soundcorset Membership" }
    ,"basicMonth":  { "iOS": "basicMonth",        "android": "basic_sub_month",   "price": "$5.49",    "title": "Soundcorset Membership"}
    ,"noAd":        { "iOS": "removeAds",         "android": "no_ad_sub",         "price": "$3.99",    "title": "No-ad Membership"}
    ,"noAdMonth":   { "iOS": "removeAdsMonth",    "android": "no_ad_sub_month",   "price": "$0.99",    "title": "No-ad Membership"}
}

export const MembershipService = {
    getMembershipInfo: (): void => {
        hostAppCall("getMembershipInfo");
    },
    purchaseBasicMonth: (): void => purchase("basicMonth"),
    isBasicMember: (): boolean => isBasic(localStorage.getItem("membership") ?? ""),
    getMembershipTitle: (): string => getMembershipTitle(getProductId(localStorage.getItem("membership") ?? ""))
}
